import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import { useFormikContext, Field } from 'formik';
import { Input } from '../../Input/component.js';
import { FieldTypes } from '../../../types.js';
var _excluded = ["customValidityMessage", "validators", "label", "type", "value", "onChange", "changeHandler", "name"];
var PasswordField = function PasswordField(_ref) {
  _ref.customValidityMessage;
  _ref.validators;
  _ref.label;
  _ref.type;
  var value = _ref.value;
  _ref.onChange;
  _ref.changeHandler;
  var name = _ref.name,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var toggleShowPassword = useCallback(function () {
    return setShowPassword(!showPassword);
  }, [showPassword]);
  var formikContext = useFormikContext();
  if (!formikContext) {
    throw Error('The <PasswordField /> component must be wrapped in a Formik context.  Did you mean to use the Core.Input with type `password` instead?');
  }
  var setFieldValue = formikContext.setFieldValue;
  var clearField = useCallback(function () {
    setFieldValue(name, '', true);
  }, [name, setFieldValue]);
  return /*#__PURE__*/React.createElement(Field, _extends({
    as: Input,
    type: showPassword ? FieldTypes.text : FieldTypes.password,
    value: value,
    name: name,
    clearField: clearField
  }, rest, {
    toggleShowPassword: toggleShowPassword,
    showPassword: showPassword
  }));
};
PasswordField.displayName = "PasswordField";
export { PasswordField };